<template>
    <div>
        <Header title="测评信息" memo="管理测评信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select v-model="query.state" @change="execQuery" :style="{ width: '150px' }">
                            <a-select-option value="">
                                所有测评
                            </a-select-option>
                            <a-select-option value="Wait">
                                未开始
                            </a-select-option>
                            <a-select-option value="Run">
                                进行中
                            </a-select-option>
                            <a-select-option value="Pause">
                                已暂停
                            </a-select-option>
                            <a-select-option value="Finish">
                                已完成
                            </a-select-option>
                            <a-select-option value="Abort">
                                已中止
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-select show-search v-model="query.oid" :filter-option="false" :not-found-content="null" @search="doLoadOrg" @change="execQuery" :style="{ width: '150px' }">
                            <a-select-option value="">
                                所有组织
                            </a-select-option>
                            <a-select-option v-for="item in orgs" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.tid" placeholder="用户账号" @pressEnter="execQuery" :style="{ width: '150px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="tuser" ellipsis width="400px">
                <span slot="title">测评用户</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                账号：
                                <span>{{ record.tuser.id }}</span>
                            </p>
                            <p>
                                姓名：
                                <span>{{ record.tuser.name }}</span>
                            </p>
                            <p>
                                分组：
                                <span>{{ record.tuser.org }}</span>
                            </p>
                            <p>
                                性别：
                                <span>{{ record.tuser.gender === 'M' ? '男' : '女' }}</span>
                            </p>
                            <p>
                                年龄：
                                <span>{{ record.age + ' 周岁' }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>用户信息</span>
                        </template>
                        <span>{{ record.tuser.name }} [{{ record.tuser.id }}] / {{ record.tuser.gender === 'M' ? '男' : '女' }} / {{ record.tuser.org }}</span>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="id" ellipsis>
                <span slot="title">测评信息</span>
                <template slot-scope="text, record">
                    <template v-if="record.type === 'Exam'">
                        <a-popconfirm title="是否中止进行中的测评？" @confirm="doAbortTesting(record.id)" v-if="record.state != 'Finish' && record.state != 'Abort'">
                            <a-icon slot="icon" type="question-circle-o" style="color: red" />
                            <a-button icon="stop" :style="{ color: 'red' }">中止测评</a-button>
                        </a-popconfirm>
                    </template>
                    <template v-else>
                        <a-popconfirm title="是否完成进行中的训练？" @confirm="doFinishTesting(record.id)" v-if="record.state != 'Finish' && record.state != 'Abort'">
                            <a-icon slot="icon" type="question-circle-o" style="color: orchid" />
                            <a-button icon="check" :style="{ color: 'orange' }">完成训练</a-button>
                        </a-popconfirm>
                    </template>
                    <a-popconfirm v-if="record.state === 'Abort'" title="'是否删除测评信息，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button icon="delete" :style="{ color: 'red' }">删除测评</a-button>
                    </a-popconfirm>
                    <a-popover placement="top" :style="{ marginLeft: '10px' }">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.id }}</span>
                            </p>
                            <p>
                                进度：
                                <span>{{ record.step }}</span>
                            </p>
                            <p>
                                状态：
                                <span>{{ record.state | testingState }}</span>
                            </p>
                            <p>
                                开始：
                                <span>{{ record.start }}</span>
                            </p>
                            <p>
                                结束：
                                <span>{{ record.end || '----' }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评信息</span>
                        </template>
                        <template>
                            <span v-if="record.delete" style="text-decoration: line-through; color: red">{{ record.id }} [{{ record.step }}] 已删除</span>
                            <span v-else>{{ record.id }} [{{ record.step }}]</span>
                        </template>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="score" ellipsis width="200px">
                <span slot="title">测评结果</span>
                <template slot-scope="text, record">
                    <template v-if="record.level">
                        <a-tag color="#2db7f5" style="width: 85px; text-align: center;">{{ record.level }}</a-tag>
                        {{ record.score }}
                    </template>
                    <span style="color: indianred;" v-else>测评未完成</span>
                </template>
            </a-table-column>
            <a-table-column key="rid" ellipsis width="150px">
                <span slot="title">测评报告</span>
                <template slot-scope="text, record">
                    <template v-if="record.level">
                        <a-button icon="download" @click="doDownReport(record)" v-if="record.rid">
                            下载报告
                        </a-button>
                        <a-button type="primary" icon="pic-right" @click="showReportForm(record)" v-else>
                            发布报告
                        </a-button>
                    </template>
                    <span style="color: indianred;" v-else>测评未完成</span>
                </template>
            </a-table-column>
            <a-table-column key="create" ellipsis width="150px">
                <span slot="title">添加人员</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.create.id }}</span>
                            </p>
                            <p>
                                时间：
                                <span>{{ record.create.time }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>添加人员</span>
                        </template>
                        <span>{{ record.create.name }}</span>
                    </a-popover>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <ReportComp title="发布测评报告" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></ReportComp>
    </div>
</template>

<script>
import ReportComp from './ReportComp'

export default {
    name: 'AteUnitTestingExam',
    components: {
        ReportComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            orgs: [],
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                uid: '',
                tid: '',
                oid: '',
                type: 'Exam',
                state: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            form: false,
            now: {}
        }
    },
    filters: {
        testingState: value => {
            switch (value) {
                case 'Wait':
                    return '未开始'
                case 'Run':
                    return '进行中'
                case 'Pause':
                    return '暂停中'
                case 'Finish':
                    return '已完成'
                case 'Abort':
                    return '已中止'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评信息'])
        this.doLoadOrg()
        this.doLoad()
    },
    methods: {
        doLoadOrg(name) {
            this.$http
                .get('/cts/ate/tester/org/query', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.orgs = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/cts/ate/testing/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/testing/mgr/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doAbortTesting(id) {
            this.$http
                .post('/cts/ate/testing/mgr/abort', {
                    id: id,
                    cause: '中止测评'
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('中止测评成功')
                        this.doLoad()
                    }
                })
        },
        doFinishTesting(id) {
            this.$http
                .post('/cts/ate/testing/mgr/finish', {
                    id: id
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('操作成功')
                        this.doLoad()
                    }
                })
        },
        doDownReport(item) {
            this.$http
                .get('/cts/ate/testing/mgr/report/down', {
                    params: {
                        _: new Date().getTime(),
                        id: item.rid
                    }
                })
                .then(result => {
                    if (result.code === 0) {
                        window.open(result.data.url)
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                uid: '',
                tid: '',
                oid: '',
                type: 'Exam',
                state: ''
            }
            this.doLoad()
        },
        showReportForm(item) {
            this.now = item
            this.form = true
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.id)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的测评信息')
                return
            }
            this.$confirm({
                title: '是否删除以下测评信息？删除后无法恢复。',
                content: '编号：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
